export const GET_ALL_ACTIVE_ADMINS = 'GET_ALL_ACTIVE_ADMINS';
export const GET_ACTIVE_ADMIN_SUCCESS = 'GET_ACTIVE_ADMIN_SUCCESS';
export const GET_ACTIVE_ADMIN_URL = 'GET_ACTIVE_ADMIN_URL';
export const GET_INACTIVE_ADMIN_SUCCESS = 'GET_INACTIVE_ADMIN_SUCCESS';
export const GET_INACTIVE_ADMIN_URL = 'GET_INACTIVE_ADMIN_URL';
export const SEARCH_ADMIN_SUCCESS = 'SEARCH_ADMIN_SUCCESS';
export const SET_PAGE_ADMIN_PAGE_SUCCESS = 'SET_PAGE_ADMIN_PAGE_SUCCESS';
export const DELETE_ADMIN_SUCCESS = 'DELETE_ADMIN_SUCCESS';
